var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#0B76FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2775 7.12124V5.88374L11.25 8.22937L8.76375 3.94312V6.75562L10.0294 8.94937L9.5175 9.25312L8.76375 7.92562L7.95375 9.36561L7.39125 9.13499L8.76375 6.75562V3.94312L6.04125 8.57811L2.25 7.00874V8.44312L5.625 9.27561L3.4875 12.9431H8.76375V11.43H6.06938L7.07625 9.66374L7.68375 9.81562L7.07625 10.8844H10.4513L9.945 9.98999L10.6144 9.93937L11.475 11.43H8.76375V12.9431H14.0625L12.24 9.83249L15.3 9.60749V8.36437L11.8575 9.21374L15.2944 8.33062V7.20562L11.565 8.71874L15.2775 7.12124ZM10.3837 9.56812L9.77625 9.71999L10.3725 9.56812H10.3837ZM10.1925 9.23062L9.63 9.45562L10.1925 9.22499V9.23062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeam);
export default __webpack_public_path__ + "static/media/beam.f8cfd2367a472460502dc7b351e466b1.svg";
export { ForwardRef as ReactComponent };